import React from "react";
import { useTranslation } from "react-i18next";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description this page String Library's Split Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Split({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const options = {
    radioButtons: {
      data: [
        {
          value: "active",
          label: label + "CASESENSITIVE",
        },
        {
          value: "passive",
          label: label + "CASENOTSENSITIVE",
        },
      ],
      defaultValue: "active",
    },
  };
  return (
    <div>
      <div className="form-element">
        {t(label + "SOURCESTRING")}
        <TextInput
          action={action}
          inputName="sourceString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          displayName={t(label + "SOURCESTRING")}
          fieldType={"string"}
        />
      </div>
      <div className="form-element">
        {t(label + "DELIMITER")}
        <TextInput
          action={action}
          inputName="delimiter"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          displayName={t(label + "DELIMITER")}
          fieldType={"string"}
        />
      </div>
      <div className="form-element">
        <strong>{t(label + "DELIMITERIS")}</strong>
        <RadioButtons
          action={action}
          inputName="isSensitive"
          isRequired={true}
          options={options.radioButtons}
        />
      </div>
      <div className="form-element">
        {t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired
        />
      </div>
    </div>
  );
}
